import React, {useState, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import TyreTableRow from './TyreTableRow';
import {
  PricelistCard as StyledPricelistCard,
  CardHeader,
  CardHeaderLeft,
  CardTitle,
  CardSubtitle,
  // AddTyreIconButton,
  SearchContainer,
  SearchInput,
  CardBody,
  TyreTable,
  Table,
  Thead,
  Th,
  Tbody,
  EmptyState,
} from '../PriceListsPage.style';

const PricelistCard = ({
  pricelist,
  pricelistKey,
  // onAddTyre,
  onPriceEdit,
  onSavePrice,
  onDeleteTyre,
  onEditTyre,
  editingPrice,
  onEditingPriceChange,
}) => {
  const {t} = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const tyres = useMemo(() => pricelist?.tyres || [], [pricelist?.tyres]);

  // Filter tyres based on search term
  const filteredTyres = useMemo(() => {
    if (!searchTerm.trim()) {
      return tyres;
    }

    const search = searchTerm.toLowerCase();
    return tyres.filter(
      (tyre) =>
        (tyre.catalogNumber || '').toLowerCase().includes(search) ||
        (tyre.ean || '').toLowerCase().includes(search) ||
        (tyre.dimension || '').toLowerCase().includes(search) ||
        (tyre.model || '').toLowerCase().includes(search)
    );
  }, [tyres, searchTerm]);

  return (
    <StyledPricelistCard>
      <CardHeader>
        <CardHeaderLeft>
          <CardTitle>{pricelist.brand}</CardTitle>
          <CardSubtitle>{pricelist.seasonLabel}</CardSubtitle>
        </CardHeaderLeft>
        {/* <AddTyreIconButton onClick={() => onAddTyre(pricelistKey, pricelist)}>
          <i className="mdi mdi-plus" />
          {t('add')}
        </AddTyreIconButton> */}
      </CardHeader>

      {tyres.length > 0 && (
        <SearchContainer>
          <SearchInput
            type="text"
            placeholder={t('searchByDimensionOrModel')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </SearchContainer>
      )}

      <CardBody>
        <TyreTable>
          {tyres.length === 0 ? (
            <EmptyState>
              <i className="mdi mdi-car-tire-alert" />
              <p>{t('noTyresAdded')}</p>
            </EmptyState>
          ) : filteredTyres.length === 0 ? (
            <EmptyState>
              <i className="mdi mdi-magnify" />
              <p>{t('noTyresFound')}</p>
            </EmptyState>
          ) : (
            <Table>
              <Thead>
                <tr>
                  <Th>{t('catalog')}</Th>
                  <Th>EAN</Th>
                  <Th>{t('dimension')}</Th>
                  <Th>{t('model')}</Th>
                  <Th>{t('gross')}</Th>
                  <Th>{t('net')}</Th>
                  <Th>{t('withDiscount')}</Th>
                  <Th></Th>
                </tr>
              </Thead>
              <Tbody>
                {filteredTyres.map((tyre) => (
                  <TyreTableRow
                    key={tyre.id}
                    tyre={tyre}
                    pricelistKey={pricelistKey}
                    editingPrice={editingPrice}
                    onPriceEdit={onPriceEdit}
                    onSavePrice={onSavePrice}
                    onEdit={onEditTyre}
                    onDelete={onDeleteTyre}
                    onEditingPriceChange={onEditingPriceChange}
                  />
                ))}
              </Tbody>
            </Table>
          )}
        </TyreTable>
      </CardBody>
    </StyledPricelistCard>
  );
};

PricelistCard.displayName = 'PricelistCard';

export default PricelistCard;
